import React from "react";

export const dualLensMarkdownComponents = {
	p: ({ children }) => <p className="dual-lens__md-p">{children}</p>,
	h1: ({ children }) => <h1 className="dual-lens__md-h1">{children}</h1>,
	h2: ({ children }) => <h2 className="dual-lens__md-h2">{children}</h2>,
	h3: ({ children }) => <h3 className="dual-lens__md-h3">{children}</h3>,
	h4: ({ children }) => <h4 className="dual-lens__md-h4">{children}</h4>,
	strong: ({ children }) => <strong className="dual-lens__md-strong">{children}</strong>,
	ul: ({ children }) => <ul className="dual-lens__md-ul">{children}</ul>,
	ol: ({ children }) => <ol className="dual-lens__md-ol">{children}</ol>,
	li: ({ children }) => <li className="dual-lens__md-li">{children}</li>,
	a: ({ href, children }) => (
		<a href={href} target="_blank" rel="noopener noreferrer" className="dual-lens__md-link">
			{children}
		</a>
	),
	code: ({ children }) => <code className="dual-lens__md-code">{children}</code>,
};
